import { render, staticRenderFns } from "./c-patterns-field.vue?vue&type=template&id=dc4a6bda&"
import script from "./c-patterns-field.vue?vue&type=script&lang=js&"
export * from "./c-patterns-field.vue?vue&type=script&lang=js&"
import style0 from "./c-patterns-field.vue?vue&type=style&index=0&id=dc4a6bda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports